var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 6C9.60387 6 7.6543 7.94958 7.6543 10.3459C7.6543 13.3199 11.5435 17.6858 11.7091 17.8702C11.8646 18.0434 12.1362 18.0431 12.2914 17.8702C12.457 17.6858 16.3462 13.3199 16.3462 10.3459C16.3461 7.94958 14.3966 6 12.0002 6ZM12.0002 17.0093C10.6913 15.4545 8.43692 12.387 8.43692 10.346C8.43692 8.38111 10.0354 6.78262 12.0002 6.78262C13.9651 6.78262 15.5636 8.38111 15.5636 10.3459C15.5635 12.3871 13.3095 15.454 12.0002 17.0093Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.15939C10.7943 8.15939 9.81348 9.14028 9.81348 10.3459C9.81348 11.5516 10.7944 12.5325 12 12.5325C13.2057 12.5325 14.1865 11.5516 14.1865 10.3459C14.1865 9.14028 13.2057 8.15939 12 8.15939ZM12 11.7499C11.2259 11.7499 10.5961 11.1201 10.5961 10.3459C10.5961 9.57181 11.2259 8.94202 12 8.94202C12.7741 8.94202 13.4039 9.57181 13.4039 10.3459C13.4039 11.1201 12.7741 11.7499 12 11.7499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.7a43cdffba26befc97ac21fa459733ab.svg";
export { ForwardRef as ReactComponent };